import { useAuth, useMe } from '@features/auth';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { usuariosQueries } from '../queries';
import { usuariosService } from '../services/usuariosService';
import type { FiltrosUsuarios } from '../types/Usuario';

export function useUsuarios(filtros: FiltrosUsuarios) {
  return useQuery(usuariosQueries.lista(filtros));
}

export function usePromover() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => usuariosService.promover(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: usuariosQueries.all() }),
  });
}

/** Rebaixar a si mesmo: refaz o `/me` e volta ao início; a lista não é invalidada (responderia 403). */
export function useRebaixar() {
  const qc = useQueryClient();
  const { user } = useAuth();
  const me = useMe();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (id: string) => usuariosService.rebaixar(id),
    onSuccess: async (_, id) => {
      if (id === user?.id) {
        await me.refetch();
        navigate('/', { replace: true });
      } else {
        await qc.invalidateQueries({ queryKey: usuariosQueries.all() });
      }
    },
  });
}
